/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAssetCounts
 */
export interface ControlAssetCounts {
    /**
     * 
     * @type {number}
     * @memberof ControlAssetCounts
     */
    cases: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAssetCounts
     */
    detections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAssetCounts
     */
    endpoints: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAssetCounts
     */
    events: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAssetCounts
     */
    groups: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAssetCounts
     */
    teamMembers: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAssetCounts
     */
    users: number;
}

/**
 * Check if a given object implements the ControlAssetCounts interface.
 */
export function instanceOfControlAssetCounts(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cases" in value;
    isInstance = isInstance && "detections" in value;
    isInstance = isInstance && "endpoints" in value;
    isInstance = isInstance && "events" in value;
    isInstance = isInstance && "groups" in value;
    isInstance = isInstance && "teamMembers" in value;
    isInstance = isInstance && "users" in value;

    return isInstance;
}

export function ControlAssetCountsFromJSON(json: any): ControlAssetCounts {
    return ControlAssetCountsFromJSONTyped(json, false);
}

export function ControlAssetCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAssetCounts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cases': json['cases'],
        'detections': json['detections'],
        'endpoints': json['endpoints'],
        'events': json['events'],
        'groups': json['groups'],
        'teamMembers': json['teamMembers'],
        'users': json['users'],
    };
}

export function ControlAssetCountsToJSON(value?: ControlAssetCounts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cases': value.cases,
        'detections': value.detections,
        'endpoints': value.endpoints,
        'events': value.events,
        'groups': value.groups,
        'teamMembers': value.teamMembers,
        'users': value.users,
    };
}

